import React from 'react';
import { withRouter } from 'react-router';
import { isBasicPlan, canExportEmails } from 'utils/plansHelper';

const FREE_PLAN_EMAIL_BANNER_TEXT = `Email Export has been turned off. Export unlimited email addresses when you upgrade to Pro.`;
const BASIC_PLAN_EMAIL_BANNER_TEXT = `Email Exporting is limited to the first 100 survey participants. Unlock unlimited reporting by upgrading to Pro.`;

const EmailExportBanner = ({ history, count }) => {
  const handleUpgrade = () => {
    history.push('/renew/select-plan');
  };

  if (canExportEmails() || count <= 100) {
    return null;
  }

  const bannerText = isBasicPlan()
    ? BASIC_PLAN_EMAIL_BANNER_TEXT
    : FREE_PLAN_EMAIL_BANNER_TEXT;

  return (
    <div className="upgrade-message-banner w-100">
      <div className="container">
        <div className="row">
          <div className="col-md-12 d-flex justify-content-end">
            <p className="pt-3 d-inline ml-3">{bannerText}</p>
            <button type="button" className="btn ml-4" onClick={handleUpgrade}>
              Upgrade Plan
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(EmailExportBanner);



// WEBPACK FOOTER //
// ./src/components/Banners/emailExportBanner.js